import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import colors from "core/colors";
import BaseIcon from "./BaseIcon";
var Icon = function (_a) {
    var size = _a.size, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "icon" : _b, _c = _a.ariaHidden, ariaHidden = _c === void 0 ? true : _c, fillColor = _a.fillColor, fillColorRule = _a.fillColorRule, className = _a.className;
    return (_jsx(BaseIcon, { size: size, fillColor: fillColor, fillColorRule: fillColorRule, className: className, ariaLabel: ariaLabel, ariaHidden: ariaHidden, children: _jsx("path", { fill: colors.secondary.orca, fillRule: "evenodd", d: "M3.005 3H15v12H3.005V3zM14.5 21a6.5 6.5 0 100-13 6.5 6.5 0 000 13z", clipRule: "evenodd" }) }));
};
export default Icon;
